import React from 'react';
import { compose } from 'ramda';
import FidelTourModal from './FidelTour/Modal/index.jsx';
import styleFile from './ModalOnSelectRate.js';
import { FIDELTOUR_CODE, STAR_TRAVELER_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import { connect } from 'react-redux';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import Modal from '@synergycms_core/components/generic/Modal';
import { Button, RichText, Image } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';



const ModalOnSelectRate = props => {
  const { children, theme, content } = props;
  const { classes } = theme.styles;
  const { closeCallback, loyaltyEnabled, type, currentStep } = props.config;
  const cx = theme.bind();
  const isMobile = theme && theme.width < 901;

  const getLoyaltyLogoText = (key) => {
    const translated = content ? content.t(`_%${key}%_`) : '';
    return translated.trim() !== '' && translated !== key ? translated : null;
  };

  const loyaltyLogoText = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_mobile' : 'loyalty_logo_text');
  const loyaltyLogoTextModal = getLoyaltyLogoText(isMobile ? 'loyalty_logo_text_modal_mobile' : 'loyalty_logo_text_modal');
  const logoText = loyaltyLogoTextModal || loyaltyLogoText || '';

  if(loyaltyEnabled && type === FIDELTOUR_CODE) {
    // return children
    return (
      <>
        <FidelTourModal {...props} currentStep={currentStep} view={"login"} closeCallback={closeCallback}>{children}</FidelTourModal>
      </>
    )
    // return (<FidelTourModal {...props} view={"login"}>{children}</FidelTourModal>);
  }
  if (!loyaltyEnabled) {
    return (<Modal
      innerStyle={[theme.computedInnerStyle, classes.modalStyle].join(' ')}
      contentStyle={classes.contentSTModal}
      closeButtonStyle={[classes.closeBtnStModal, type === FIDELTOUR_CODE ? classes.closeBtnFt : '']}
      modalStyle={classes.noDispoModal}
      popover={(closeModal)=>
        (<div className={[classes.modalTabsList, classes.modalStContainer].join(' ')}>
          <div className={classes.headerModal}>
            {FIDELTOUR_CODE === type && <>
              <div className={[!loyaltyLogoText ? classes.starLogo : '', classes.memberOnlyBlue].join(' ')}>
                { !!logoText ? (
                  <div className={classes.logoTextBox}>
                    <RichText
                      text={logoText}
                      translate={true}
                      dangerouslySetInnerHTML={true}
                      innerStyle={classes.loyaltyTabLogo}
                    />
                  </div>
                ) : (
                  <Image svg={'memberOnlyBlue'} innerStyle={classes.loyaltyLogo}/>
                )}
              </div>
              <RichText
                innerStyle={[classes.modalTitle, classes.ftTitle]}
                text={'_%¿estás seguro de que no quieres aprovechar nuestra tarifa members only?%_'}
                translate={true}
                ucFirst={false}
              />
              <RichText
                innerStyle={classes.modalSubTitle}
                text={'_%te estás perdiendo <b>descuentos exclusivos</b> asociados a nuestro programa de <b>Fidelización</b>.%_'}
                translate={true}
                ucFirst={false}
                dangerouslySetInnerHTML={true}
              />
            </>}

            {STAR_TRAVELER_CODE === type && <>
              <div className={classes.starLogo}>
                <Image svg={'stDefaultLogoHz'}/>
              </div>
              <RichText
                innerStyle={classes.modalTitle}
                text={'_%¿estás seguro de que no quieres aprovechar nuestra tarifa star traveler?%_'}
                translate={true}
                ucFirst={false}
              />
              <RichText
                innerStyle={classes.modalSubTitle}
                text={'_%te estás perdiendo <b>descuentos exclusivos</b> asociados a nuestro programa de <b>Fidelización</b>.%_'}
                translate={true}
                ucFirst={true}
                dangerouslySetInnerHTML={true}
              />
            </>}
            <div className={classes.btnsContainer}>
              <Button innerStyle={[classes.upercase, cx({ftBtnInterest: type === FIDELTOUR_CODE }), classes.buttonInterest]} onClick={()=>{closeCallback();  closeModal()}}>
                <RichText
                  text={'_%me interesa%_'}
                  translate={true}
                  ucFirst={false}
                />
              </Button>
              <Button innerStyle={[classes.ButtonNoInterest, type === FIDELTOUR_CODE ? classes.ftNoInterest : '']} onClick={()=>{closeCallback(true); closeModal();}}>
                <RichText
                  text={'_%no gracias%_'}
                  translate={true}
                  ucFirst={true}
                />
              </Button>
            </div>
            
          </div>
        </div>)
      }
      typeModal={'roomDetailTooltip'}>
        {(toggle)=> children(toggle)}
    </Modal>);
  } else {
    return (children());
  }

};

const mapStateToProps = (store) => {
  const loyalty = store.getIn(["customer", "loyalty", "data", "loyalty"]);
  const currentStep = store.getIn(['customer', 'step', 'current_step', 'code'], null);

  return {
    loyalty,
    type: loyalty && loyalty.get("code"),
    currentStep
  }
};

export default compose(
  connect(mapStateToProps),
  PropertyManager([ 'closeCallback','children', "loyaltyEnabled","type","currentStep"]),
  withThemeJSS({ styleFile, link: true, displayName: 'LoyaltySureModal' }),
  withContent('i18n'),
)(ModalOnSelectRate);
